<div class="col-xs-12 col-md-10 col-lg-12 payment-info_headersection">
  <div class="payment-info_headertext">{{"paymentinfo.title" | cxTranslate}}</div>
</div>
<div class="col-xs-12 col-lg-12 payment-info_section main">
  <div class=" payment-info_savedCards ">
    <div class=" payment-info_Cardsheader col-md-12 col-12 no-padding">
      <div class="payment-info_Cardsheader-text ">{{"paymentinfo.savecctext" | cxTranslate}}</div>
      @if (creditdetails.cardsData.length > 0) {
        <div class="payment-info_Cardsheader-tooltip" [innerHTML]="'paymentinfo.savecctooltiptext' | cxTranslate">{{"paymentinfo.savecctooltiptext" | cxTranslate}}
        </div>
      }
    </div>

    @if (creditdetails.cardsData.length > 0) {
      <div id="DataTables" class="col-sm-12 dataTables_wrapper no-footer no-padding">
        <table class="payment-info_savedCards-table dataTable " id="DataTables_Table_" role="grid">
          <tbody>
            @for (card of creditdetails?.cardsData; track card; let p = $index) {
              <tr>
                <td>
                  <div class="savedcard-parent" id=p>
                    @if (card.cardType == '1') {
                      <img width="75" class="image" src="../../assets/images/Visa_icon.png"
                        alt="Visa">
                    }
                    @if (card.cardType == '2') {
                      <img width="75" class="image" src="../../assets/images/amex_icon.png"
                        alt="American Express">
                    }
                    @if (card.cardType == '3') {
                      <img width="75" class="image" src="../../assets/images/master_icon.png"
                        alt="MasterCard">
                    }
                    @if (card.cardType == '128') {
                      <img width="75" class="image" src="../../assets/images/Discover_icon.png"
                        alt="Discover">
                    }
                    <div class="savedcard-cardno">{{formatCard(card.cardNumber)}}
                      <p class="savedcard-expireDate" [ngClass]="getExpiryClass(card.expiryDate)">
                        @if (card.expiryTime == 'past') {
                          {{"paymentinfo.expiredtxt" | cxTranslate}} {{ card.expiryDate }}&nbsp;
                        }
                        @if (card.expiryTime != 'past') {
                          {{"paymentinfo.expirestxt" | cxTranslate}} {{ card.expiryDate }}&nbsp;
                        }
                        @if (getExpiryClass(card.expiryDate) === 'expired') {
                          <img class="icon"
                            src="../../assets/images/exclamation-mark.png">
                          }
                        </p>
                      </div>
                      <button class="savedcard-delete" data-toggle="modal" data-value="{{ card.token }}"
                        (click)="handleOnDelete(card)">{{"paymentinfo.deletelabel" | cxTranslate}} <i
                      class="fa fa-trash-o" aria-hidden="true"></i>
                    </button>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>

  @if (!creditdetails.cardsData.length) {
    <div class="payment-info_nosavedCards">{{"paymentinfo.nosavedcardmsg" | cxTranslate}}</div>
  }

  <div class="payment-info_addCards ">
    <div class="payment-info_Cardsheader-text ">{{"paymentinfo.addcctext" | cxTranslate}}
      <i class="fa fa-question-circle-o payment-info-tooltip">
        <span class="payment-info_Cardsheader-tooltiptext newcredit-tooltip">{{"paymentinfo.newcardtooltiptxt" | cxTranslate}}</span>
      </i>
      <div class="payment-info_iframe ">
        <iframe width="100%" height="400" frameborder="0" [attr.src]="trustedUrl">
        </iframe>
      </div>
    </div>
  </div>
</div>
<!-- </div> -->
<div id="payment-info_deletemodal" class="modal fade" role="dialog" [ngClass]="confirmDeletemodal?'show':'hide'">
  <div class="modal-dialog">

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-body">
        <div class="knowledgeHub_abandonedPopHeader">
          <div class="payment-info_deleteheader">{{"paymentinfo.delcardlabel" | cxTranslate}}</div>
          <div class="no-padding pull-right" data-bs-dismiss="modal">×</div>
          <div class="clearboth"></div>
        </div>
        <p class="payment-info_deletesubheader col-xs-12">
          {{"paymentinfo.deletemsg1" | cxTranslate}} {{cardMap[selectedCardData?.cardType]}} {{"paymentinfo.deletemsg2" | cxTranslate}} {{selectedCardData?.cardNumber.slice(-4)}} {{"paymentinfo.deletemsg3" | cxTranslate}}
          <div class="clearboth"></div>
          <div class="payment-info_deletebuttons">
            <button class="payment-info_deleteYes global_redbtn" data-toggle="modal" data-bs-dismiss="modal"
            (click)="confirmDelete()">{{"paymentinfo.yeslabel" | cxTranslate}}</button>
            <button class="payment-info_deleteNo global_greybtn" data-bs-dismiss="modal" #closeButton>{{"paymentinfo.nolabel" | cxTranslate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="schedulepay_deletemodal" class="modal fade" role="dialog" >
    <div class="modal-dialog">

      <!-- Modal content-->
      <div class="modal-content">
        <div class="modal-body">
          <h4 class="modal-title schpayment-info_deleteheader col-xs-9">{{"paymentinfo.cardusetxt" | cxTranslate}}</h4>
          <div class="col-xs-3 no-padding pull-right"><span class="payment-info_close" data-bs-dismiss="modal">×</span></div>

          <div class="schpay_Content">
            <div class="schpay_modaltext">Your {{cardMap[selectedCardData?.cardType]}} {{"paymentinfo.deletemsg2" | cxTranslate}} {{selectedCardData?.cardNumber.slice(-4)}} {{"paymentinfo.cardschpaymsg" | cxTranslate}}<br/></div>
            <div class="schpay_modaltext subheader">You must <span class="cancel_Txt">cancel scheduled payments that use this card </span>before the card can be deleted.</div>
          </div>
          <div class="payment-info_deletebuttons">
            <button class="payment-info_deleteYes global_redbtn" data-bs-dismiss="modal" routerLink="/scheduled-payments">{{"paymentinfo.schpaylabel" | cxTranslate}}</button>
            <button class="payment-info_deleteNo global_greybtn" data-bs-dismiss="modal" #closeButton>{{"paymentinfo.closelabel" | cxTranslate}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
